module.exports = __webpack_public_path__ + "img/2022-Literatur-Preis-ZAG_4675_-scaled.f28ac70b.jpg";